import { useCallback, SyntheticEvent } from 'react'
import {
  fetchRelatedRecords,
  useDataProvider,
  useNotify,
  useListContext,
  useResourceContext,
} from 'react-admin'
import { useExportProps, useExportResult } from './type'

export const useExport = (props: useExportProps = {}): useExportResult => {
  const { maxResults = 1000, exporter: customExporter, onError, onSuccess, ...restProps } = props
  const { filter, filterValues, sort, exporter: exporterFromContext } = useListContext(restProps)
  const resource = useResourceContext()
  const exporter = customExporter || exporterFromContext
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const onExport = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async (event: SyntheticEvent) => {
      try {
        const { data /* , total */ } = await dataProvider.getList(resource, {
          sort,
          filter: filter ? { ...filterValues, ...filter } : filterValues,
          pagination: { page: 1, perPage: maxResults },
        })
        if (data && exporter) {
          exporter(data, fetchRelatedRecords(dataProvider), dataProvider, resource)
          onSuccess && onSuccess()
        }
      } catch (error) {
        onError && onError(error)
        notify('ra.notification.http_error', { type: 'warning' })
      }
    },
    [
      dataProvider,
      exporter,
      filter,
      filterValues,
      maxResults,
      notify,
      onError,
      onSuccess,
      resource,
      sort,
    ],
  )

  return {
    onExport,
  }
}
